<template>
    <div class="base-card__content base-card__zoom base-card__shadow channel-content">
        <img 
            v-if="imageUrl" 
            class="channel-content__image"
            alt=""
            :src="imageUrl"
            loading="lazy">
        <common-icon v-else class="credit-content__image" :icon-name="'IconNoPicture'" />
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from "vue";
    import { type GenreCardData } from "../../models";
    import { computed } from "vue";

    const props = defineProps({
        cardData: {
            type: Object as PropType<GenreCardData>,
            required: true
        },
    });

    const imageUrl = computed((): string => {
        const image = props.cardData.getImage();

        if (!image) {
            return '';
        } else {
            return `${image}&width=${260}`;
        }
    });
</script>

<style lang="scss">
    @import url("styles.scss");
</style>